import qs from "qs";
import {
    ID_FILTER_SEARCH,
    ID_FILTER_TOLL_CUSTOMER_ID,
    ID_FILTER_TOLL_CUSTOMER_NAME,
    ID_FILTER_TOLL_DEALERS,
    ID_FILTER_TOLL_ENTRY_DATE_FROM,
    ID_FILTER_TOLL_ENTRY_DATE_TO,
    ID_FILTER_TOLL_EQUIPMENT_NUMBER,
    ID_FILTER_TOLL_EXIT_NAME,
    ID_FILTER_TOLL_FARE_AMOUNT_FROM,
    ID_FILTER_TOLL_FARE_AMOUNT_TO,
    ID_FILTER_TOLL_LEGAL_ENTITIES,
    ID_FILTER_TOLL_PLATE,
    ID_FILTER_TOLL_RA_CODE,
    ID_FILTER_TOLL_STATUSES,
    ID_FILTER_TOLL_VAT_RATE
} from "../../pages/etoll/constants/ETollConstants";
import {FilterDef, HTTPGenericResponse} from "../../constants/FinanceModels";
import {getFilterValue} from "../../utils/FilterUtils";
import {useApi} from "../Api";
import {useContext} from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";

export const useETollChargesRepository = () => {
    const {GET} = useApi();

    const PATH = "/finance/etoll/charges"

    const {globalData: {user}} = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);

    async function getCharges(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let equipmentNumber = getFilterValue(ID_FILTER_TOLL_EQUIPMENT_NUMBER, filterDefs);
        let plate = getFilterValue(ID_FILTER_TOLL_PLATE, filterDefs);
        let tollDateFrom = getFilterValue(ID_FILTER_TOLL_ENTRY_DATE_FROM, filterDefs);
        let tollDateTo = getFilterValue(ID_FILTER_TOLL_ENTRY_DATE_TO, filterDefs);
        let exitTollName = getFilterValue(ID_FILTER_TOLL_EXIT_NAME, filterDefs);
        let vatRate = getFilterValue(ID_FILTER_TOLL_VAT_RATE, filterDefs);
        let fareAmountFrom = getFilterValue(ID_FILTER_TOLL_FARE_AMOUNT_FROM, filterDefs);
        let fareAmountTo = getFilterValue(ID_FILTER_TOLL_FARE_AMOUNT_TO, filterDefs);
        let customerId = getFilterValue(ID_FILTER_TOLL_CUSTOMER_ID, filterDefs);
        let raCode = getFilterValue(ID_FILTER_TOLL_RA_CODE, filterDefs);
        let status = getFilterValue(ID_FILTER_TOLL_STATUSES, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_TOLL_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_TOLL_DEALERS, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            search: search,
            equipmentNumber: equipmentNumber,
            registration: plate,
            from: tollDateFrom,
            to: tollDateTo,
            exitTollName: exitTollName,
            vatRate: vatRate,
            fareAmountFrom: fareAmountFrom,
            fareAmountTo: fareAmountTo,
            customerId: customerId,
            raCode: raCode,
            status: status,
            legalEntities,
            dealers
        }

        let response = await GET(`${PATH}/all`, {
            params: params,
            paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });

        return new Promise((resolve) => {
            let generic: HTTPGenericResponse = {
                code: 200,
                status: 'OK',
                message: '',
                result: response
            }
            resolve(generic);
        })
    }

    async function getChargesByReport(reportId: string, offset: number, limit: number, sort: string | null, order: string | null): Promise<HTTPGenericResponse> {
        const allDealers: any[] = user.dealers?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            reportId: reportId,
            legalEntities: allLegalEntities,
            dealers: allDealers
        }

        var response = await GET(`${PATH}/all`, {
            params: params,
            paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        }, true);

        return new Promise((resolve) => {
            let generic: HTTPGenericResponse = {
                code: 200,
                status: 'OK',
                message: '',
                result: response
            }
            resolve(generic);
        })
    }

    function getSummary(filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let equipmentNumber = getFilterValue(ID_FILTER_TOLL_EQUIPMENT_NUMBER, filterDefs);
        let plate = getFilterValue(ID_FILTER_TOLL_PLATE, filterDefs);
        let tollDateFrom = getFilterValue(ID_FILTER_TOLL_ENTRY_DATE_FROM, filterDefs);
        let tollDateTo = getFilterValue(ID_FILTER_TOLL_ENTRY_DATE_TO, filterDefs);
        let exitTollName = getFilterValue(ID_FILTER_TOLL_EXIT_NAME, filterDefs);
        let vatRate = getFilterValue(ID_FILTER_TOLL_VAT_RATE, filterDefs);
        let fareAmountFrom = getFilterValue(ID_FILTER_TOLL_FARE_AMOUNT_FROM, filterDefs);
        let fareAmountTo = getFilterValue(ID_FILTER_TOLL_FARE_AMOUNT_TO, filterDefs);
        let customerId = getFilterValue(ID_FILTER_TOLL_CUSTOMER_ID, filterDefs);
        let raCode = getFilterValue(ID_FILTER_TOLL_RA_CODE, filterDefs);
        let status = getFilterValue(ID_FILTER_TOLL_STATUSES, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_TOLL_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_TOLL_DEALERS, filterDefs);

        let params = {
            search: search,
            equipmentNumber: equipmentNumber,
            registration: plate,
            from: tollDateFrom,
            to: tollDateTo,
            exitTollName: exitTollName,
            vatRate: vatRate,
            fareAmountFrom: fareAmountFrom,
            fareAmountTo: fareAmountTo,
            customerId: customerId,
            raCode: raCode,
            status: status,
            legalEntities,
            dealers
        }

        return GET(`${PATH}/all-status-summary`, {
            params: params,
            paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
    }

    return {getCharges, getChargesByReport, getSummary};
}